import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { STORAGEKEY } from "../components/Constant";

// Pages
const PagesInvoice = lazy(() => import("../pages/Utility/invoice"));
const Pages404 = lazy(() => import("../pages/Utility/pages-404"));
const Pages500 = lazy(() => import("../pages/Utility/pages-500"));
const PagesComingsoon = lazy(() => import("../pages/Utility/pages-comingsoon"));
const PagesFaqs = lazy(() => import("../pages/Utility/pages-faqs"));
const PagesMaintenance = lazy(
  () => import("../pages/Utility/pages-maintenance"),
);
const PagesPricing = lazy(() => import("../pages/Utility/pages-pricing"));
const PagesStarter = lazy(() => import("../pages/Utility/pages-starter"));
const PagesTimeline = lazy(() => import("../pages/Utility/pages-timeline"));

// Tables
const BasicTables = lazy(() => import("../pages/Tables/BasicTables"));
const DatatableTables = lazy(() => import("../pages/Tables/DatatableTables"));
// const EditableTables = lazy(() => import("../pages/Tables/EditableTables"));
const ResponsiveTables = lazy(() => import("../pages/Tables/ResponsiveTables"));

// Icons
const IconBoxicons = lazy(() => import("../pages/Icons/IconBoxicons"));
const IconDripicons = lazy(() => import("../pages/Icons/IconDripicons"));
const IconFontawesome = lazy(() => import("../pages/Icons/IconFontawesome"));
const IconMaterialdesign = lazy(
  () => import("../pages/Icons/IconMaterialdesign"),
);
const IconUnicons = lazy(() => import("../pages/Icons/IconUnicons"));

// Authentication
const Logout = lazy(() => import("../pages/Authentication/Logout"));
const Login1 = lazy(() => import("../pages/AuthenticationInner/Login"));
const Recoverpw = lazy(() => import("../pages/AuthenticationInner/Recoverpw"));
const Register1 = lazy(() => import("../pages/AuthenticationInner/Register"));
const LockScreen = lazy(
  () => import("../pages/AuthenticationInner/auth-lock-screen"),
);

// Profile
const UserProfile = lazy(() => import("../pages/Authentication/user-profile"));

// User Authentication
const ForgetPasswordPage = lazy(
  () => import("../pages/UserAuthentication/ForgotPassword"),
);
const Login = lazy(() => import("../pages/UserAuthentication/Login"));
const Register = lazy(() => import("../pages/UserAuthentication/Register"));
const ResetPassword = lazy(
  () => import("../pages/UserAuthentication/ResetPassword"),
);

// Dashboards
const BookedUnits = lazy(() => import("../pages/Dashboards/BookedUnits"));
const CustomerDetails = lazy(
  () => import("../pages/Dashboards/CustomerDetails"),
);
const CustomerRevenue = lazy(
  () => import("../pages/Dashboards/CustomerRevenue"),
);
const DashboardGeneralExpanses = lazy(
  () => import("../pages/Dashboards/GeneralExpanses"),
);
const MonthlyInterest = lazy(
  () => import("../pages/Dashboards/MonthlyInterests"),
);
const PartyByDepartment = lazy(
  () => import("../pages/Dashboards/PartyByDepartment"),
);
const PartyDetails = lazy(() => import("../pages/Dashboards/PartyDetails"));
const PartyExpenseDetails = lazy(
  () => import("../pages/Dashboards/PartyExpenseDetails"),
);
const ProjectDashboard = lazy(
  () => import("../pages/Dashboards/ProjectDashboard"),
);
const RawMaterialOverview = lazy(
  () => import("../pages/Dashboards/RawMaterialOverview"),
);
const DashboardStaffSalary = lazy(
  () => import("../pages/Dashboards/StaffSalary"),
);
const UnpaidUnits = lazy(() => import("../pages/Dashboards/UnpaidUnits"));
const Dashboard = lazy(() => import("../pages/GeneralDashboard/Dashboard"));
const UserDashboard = lazy(() => import("../pages/UserDashboard/index"));
const BookingList = lazy(() => import("../pages/BookingList"));

// Configurations
const CustomerConfiguration = lazy(
  () => import("../pages/Configurations/CustomerConfiguration"),
);
const DepartmentConfiguration = lazy(
  () => import("../pages/Configurations/DepartmentConfiguration"),
);
const EmployeeConfiguration = lazy(
  () => import("../pages/Configurations/EmployeeConfiguration"),
);
const GeneralExpenseConfiguration = lazy(
  () => import("../pages/Configurations/GeneralExpenseConfiguration"),
);
const PartyConfiguration = lazy(
  () => import("../pages/Configurations/PartyConfiguration"),
);
const ProjectConfiguration = lazy(
  () => import("../pages/Configurations/ProjectConfiguration"),
);
const SubDepartmentConfiguration = lazy(
  () => import("../pages/Configurations/SubDepartmentConfiguration"),
);
const UnitConfiguration = lazy(
  () => import("../pages/Configurations/UnitConfiguration"),
);

// Management
const CustomersProjectData = lazy(() => import("../pages/Customer"));
const Customers = lazy(() => import("../pages/Customer/GetCustomer"));
const Departments = lazy(() => import("../pages/Department"));
const DepartmentExpenses = lazy(
  () => import("../pages/Department/DepartmentExpenses"),
);
const Employees = lazy(() => import("../pages/Employee"));
const Parties = lazy(() => import("../pages/Party"));
const PartyRate = lazy(() => import("../pages/Party/PartyRate"));
const Projects = lazy(() => import("../pages/Projects"));
const ArchivedProject = lazy(() => import("../pages/Projects/archivedProject"));
const ProjectUnits = lazy(() => import("../pages/Units"));

// Expenses / Daily Entry
const CancelUnitBooking = lazy(() => import("../pages/CancelUnitBooking"));
const GeneralBills = lazy(
  () => import("../pages/DailyEntry/Expense/GeneralBills"),
);
const PartyBills = lazy(() => import("../pages/DailyEntry/Expense/PartyBills"));
const PartyPaidBills = lazy(
  () => import("../pages/DailyEntry/Expense/PartyPaidBills"),
);
const AddProjectExpenses = lazy(
  () => import("../pages/DailyEntry/Expense/ProjectExpense"),
);
const AddRevenue = lazy(() => import("../pages/DailyEntry/Revenue/revenue"));
const DailyLedger = lazy(() => import("../pages/DailyLedger"));
const EmployeeSalaryDetails = lazy(
  () => import("../pages/Employee/EmployeeDetails"),
);
const EmployeeSalary = lazy(() => import("../pages/Employee/EmployeeSalary"));
const GeneralExpenses = lazy(() => import("../pages/GeneralExpense"));
const ViewDetails = lazy(() => import("../pages/InterestDetails/ViewDetails"));
const InterestDetails = lazy(() => import("../pages/InterestDetails/index"));
const PartyExpense = lazy(() => import("../pages/PartyExpenses.js/index.js"));
const ProjectExpenses = lazy(() => import("../pages/ProjectExpense"));
const EmployeeData = lazy(() => import("../pages/StaffSalary/StaffDetail"));
const EmployeesData = lazy(() => import("../pages/StaffSalary/StaffSalary"));
const CustomerRefund = lazy(() => import("../pages/Units/CustomerRefund"));
const UnitIncome = lazy(() => import("../pages/Units/UnitIncome.js"));
const Users = lazy(() => import("../pages/Users"));
const LandPayment = lazy(() => import("../pages/land/LandPayment/index"));
const Lands = lazy(() => import("../pages/land/index"));

// Get role from localStorage
let role = localStorage.getItem(STORAGEKEY.ROLE);

// ------------------- USER ROUTES -------------------
const userRoutes = [
  { path: "/user-dashboard", element: <UserDashboard /> },

  // Utility
  { path: "/pages-starter", element: <PagesStarter /> },
  { path: "/pages-timeline", element: <PagesTimeline /> },
  { path: "/pages-faqs", element: <PagesFaqs /> },
  { path: "/pages-pricing", element: <PagesPricing /> },
  { path: "/invoice", element: <PagesInvoice /> },

  // Tables
  { path: "/tables-basic", element: <BasicTables /> },
  { path: "/tables-datatable", element: <DatatableTables /> },
  { path: "/tables-responsive", element: <ResponsiveTables /> },
  // { path: "/tables-editable", element: <EditableTables /> },

  // Icons
  { path: "/icons-unicons", element: <IconUnicons /> },
  { path: "/icons-boxicons", element: <IconBoxicons /> },
  { path: "/icons-dripicons", element: <IconDripicons /> },
  { path: "/icons-materialdesign", element: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", element: <IconFontawesome /> },

  // Profile
  { path: "/profile", element: <UserProfile /> },
];

// ------------------- AUTH ROUTES -------------------
const authRoutes = [
  { path: "/logout", element: <Logout /> },
  { path: "/user-login", element: <Login /> },
  { path: "/forgot-password", element: <ForgetPasswordPage /> },
  { path: "/user-register", element: <Register /> },
  { path: "/reset-password", element: <ResetPassword /> },

  { path: "/pages-maintenance", element: <PagesMaintenance /> },
  { path: "/pages-comingsoon", element: <PagesComingsoon /> },
  { path: "/pages-404", element: <Pages404 /> },
  { path: "/pages-500", element: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", element: <Login1 /> },
  { path: "/pages-register", element: <Register1 /> },
  { path: "/page-recoverpw", element: <Recoverpw /> },
  { path: "/auth-lock-screen", element: <LockScreen /> },
];

// ------------------- CONFIGURATION ROUTES -------------------
const configurationRoutes = [
  { path: "/project-configuration", element: <ProjectConfiguration /> },
  { path: "/customer-configuration", element: <CustomerConfiguration /> },
  { path: "/department-configuration", element: <DepartmentConfiguration /> },
  { path: "/unit-configuration", element: <UnitConfiguration /> },
  { path: "/employee-configuration", element: <EmployeeConfiguration /> },
  { path: "/party-configuration", element: <PartyConfiguration /> },
  {
    path: "/general-expense-configuration",
    element: <GeneralExpenseConfiguration />,
  },
  { path: "/users-list", element: <Users /> },
  {
    path: "/subdepartment-configuration",
    element: <SubDepartmentConfiguration />,
  },
];

// ------------------- MANAGEMENT ROUTES -------------------
const managementRoutes = [
  { path: "/project-list", element: <Projects /> },
  { path: "/customer-list", element: <CustomersProjectData /> },
  { path: "/department-list", element: <Departments /> },
  { path: "/unit-list", element: <ProjectUnits /> },
  { path: "/employee-list", element: <Employees /> },
  { path: "/party-list", element: <Parties /> },
  { path: "/department-expense", element: <DepartmentExpenses /> },
  { path: "/party-rates", element: <PartyRate /> },
  { path: "/project-unit-list", element: <Customers /> },
  { path: "/archived-project", element: <ArchivedProject /> },
];

// ------------------- EXPENSE ROUTES -------------------
const expenseRoutes = [
  { path: "/customer-revenue", element: <AddRevenue /> },
  { path: "/project-expenses", element: <AddProjectExpenses /> },
  { path: "/unit-incomes", element: <UnitIncome /> },
  { path: "/customer-refund", element: <CustomerRefund /> },
  { path: "/cancel-booking", element: <CancelUnitBooking /> },
  { path: "/material-expenses", element: <ProjectExpenses /> },
  { path: "/general-expenses", element: <GeneralExpenses /> },
  { path: "/party-expenses", element: <PartyExpense /> },
  { path: "/employee-salary", element: <EmployeeSalary /> },
  { path: "/employee-details", element: <EmployeeSalaryDetails /> },
  { path: "/general-bills", element: <GeneralBills /> },
  { path: "/party-bills", element: <PartyBills /> },
  { path: "/party-payments", element: <PartyPaidBills /> },
  { path: "/lands", element: <Lands /> },
  { path: "/land-details", element: <LandPayment /> },
  { path: "/interest-details", element: <InterestDetails /> },
  { path: "/interest-details/loan/:_id", element: <ViewDetails /> },
  { path: "/interest-details/borrow/:_id", element: <ViewDetails /> },
  { path: "/staff-salary", element: <EmployeesData /> },
  { path: "/salary-details", element: <EmployeeData /> },
];

// ------------------- DASHBOARD ROUTES -------------------
const dashboardRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/project-dashboard", element: <ProjectDashboard /> },
  { path: "/dashboard-customer-revenue", element: <CustomerRevenue /> },
  {
    path: "/dashboard-general-expanses",
    element: <DashboardGeneralExpanses />,
  },
  { path: "/dashboard-staff-salary", element: <DashboardStaffSalary /> },
  { path: "/raw-material-overview", element: <RawMaterialOverview /> },
  { path: "/party-expense-details", element: <PartyExpenseDetails /> },
  { path: "/booked-units", element: <BookedUnits /> },
  { path: "/dashboard/department-expense", element: <PartyByDepartment /> },
  { path: "/customer-details", element: <CustomerDetails /> },
  { path: "/party-details", element: <PartyDetails /> },
  { path: "/monthly-interest", element: <MonthlyInterest /> },
  { path: "/unpaid-units", element: <UnpaidUnits /> },
  { path: "/daily-ledger", element: <DailyLedger /> },
  { path: "/booking-list", element: <BookingList key="active-booking" /> },
  {
    path: "/archived-booking-list",
    element: <BookingList key="archived-booking" isArchivedView={true} />,
  },
];

// ------------------- UNDEFINED ROUTES -------------------
const undefinedRoutes = [
  {
    path: "*",
    element: (
      <Navigate
        to={role === "superAdmin" ? "/dashboard" : "/project-list"}
        replace
      />
    ),
  },
];

// ------------------- EXPORT ROUTES -------------------
export {
  authRoutes,
  configurationRoutes,
  dashboardRoutes,
  expenseRoutes,
  managementRoutes,
  undefinedRoutes,
  userRoutes,
};
